import React from "react"
import { Box, Divider, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { dsColorNew } from "@palette"


// The filters that drive a whole page, in one white strip as wide as the content: the fields at one height
// and the page actions (downloads…) at the right edge
export default function AppFilterBar({ children, actions, label = 'Filters', sx = {} }) {
	return <Box sx={{
		display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap',
		px: 2, py: 1.5, mb: 2,
		backgroundColor: dsColorNew.white, border: `1px solid ${dsColorNew.grayBorder}`, borderRadius: '14px',
		// every field of the strip at the same 40px, whatever component draws it
		'& .MuiOutlinedInput-root': { minHeight: 40 },
		'& .MuiAutocomplete-root .MuiOutlinedInput-root': { py: '1px' },
		'& .rs-picker-toggle[role="combobox"]': { minHeight: 40, display: 'flex', alignItems: 'center' },
		...sx,
	}}>
		<Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
			<Box sx={{
				width: 28, height: 28, borderRadius: '8px',
				display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
				backgroundColor: dsColorNew.pillActiveBg, color: dsColorNew.appBlue,
			}}>
				<IconSeeker icon="sliders" sx={{ fontSize: 12 }}/>
			</Box>
			<Typography sx={{ fontSize: 13, fontWeight: 600, color: dsColorNew.textTitle }}>{label}</Typography>
		</Box>
		<Divider orientation="vertical" flexItem sx={{ my: 0.75 }}/>
		{children}
		{!!actions && <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center', gap: 1 }}>{actions}</Box>}
	</Box>
}
